





import React, { useEffect , useState } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css'; 
import EnquiryDialog from '../dialog';
export const TechContact = (props) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, 
     
    });
  }, []);
  const [isDialogOpen, setIsDialogOpen] = useState(false);


  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleEnquirySubmit = (formData) => {
    console.log("Submitted:", formData);
  };

  return (
    <div id='about123'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-12'  >
            {' '}
           
          </div>  <h2  >infrastructure with cutting-edge tools and software 
</h2>
          
          


       
              <p  > <strong>At RedRuby Technologies, our diverse technological expertise empowers your infrastructure, driving efficiency and innovation. Explore the digital world with confidence, backed by our comprehensive solutions and dedicated support.
    </strong> <br/> 
    Our product development leverages breakthrough technologies and Agile processes to deliver impactful solutions tailored to your needs.</p>
           
 
<div style={{marginBottom:20  , display:"flex"   , justifyContent:"center", alignItems:"center"}} className="px-5 py-4 pb-5">
                <a href="/careers" > <button  type="submit" style={{ fontWeight:"bold" }} data-mdb-button-init data-mdb-ripple-init  className='btn btn-custom btn-lg page-scroll' data-aos='fade-up'>Get In Touch With Us</button> </a>    
                  </div>
             
        </div>
      </div>
      <EnquiryDialog isOpen={isDialogOpen} onClose={handleDialogClose} onSubmit={handleEnquirySubmit} />
    </div>
  )
}
